import React, { useState } from "react";
import styles from "./ManageDiscount.module.css";
import Header from "../../components/header/Header";
import { useToast } from "../../hooks/useToast";
import PageHeading from "../../components/PageHeading/PageHeading";

interface IDiscountForm {
  inHousePercentage: number;
  thirdPartyPercentage: number;
}

const ManageDiscount: React.FC = () => {
  const { showToast } = useToast();
  const [formData, setFormData] = useState<IDiscountForm>({
    inHousePercentage: 0,
    thirdPartyPercentage: 0,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numValue = Math.min(100, Math.max(0, Number(value)));
    setFormData((prev) => ({
      ...prev,
      [name]: numValue,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add API call to save discount percentages
    showToast("Discount percentages updated successfully", "success");
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Manage Discount" />
        <div className={styles.content}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="inHousePercentage">In-House Discount (%)</label>
              <input
                type="number"
                id="inHousePercentage"
                name="inHousePercentage"
                value={formData.inHousePercentage}
                onChange={handleInputChange}
                min="0"
                max="100"
                step="0.01"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="thirdPartyPercentage">
                Third-Party Discount (%)
              </label>
              <input
                type="number"
                id="thirdPartyPercentage"
                name="thirdPartyPercentage"
                value={formData.thirdPartyPercentage}
                onChange={handleInputChange}
                min="0"
                max="100"
                step="0.01"
                required
              />
            </div>

            <button type="submit" className={styles.submitButton}>
              Save Changes
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageDiscount;
